const SidebarItemStyles = theme => ({
    badge: {
      width: '20px',
      height: '20px',
      display: 'flex',
      zIndex: 1,
      flexWrap: 'wrap',
      fontSize: '0.75rem',
      alignItems: 'center',
      borderRadius: '50%',
      alignContent: 'center',
      flexDirection: 'row',
      justifyContent: 'center'
    },
    menuLink: {
      position: 'relative',
      display: 'block',
      textDecoration: 'none',
      marginLeft: "-10px",
    },
    menuItem: {
      fontSize: '0.9rem',
      paddingLeft: 0,
      paddingRight: 0,
    },
    menuIcon: {
      marginLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginRight: theme.spacing(2)
    },
    menuIconFa: {
      marginLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(1),
      marginRight: theme.spacing(2)
    },
    menuSubItem: {
      paddingLeft: '25px',
      paddingRight: '55px'
    },
    profileMenuItem: {
      paddingLeft: '70px',
      paddingRight: '55px'
    },
    menuCollapsed: {
      backgroundColor: theme.palette.action.hover,
    },
    menuActive: {
      backgroundColor: theme.palette.action.hover,
    },
    menuClosed: {
      backgroundColor: 'transparent'
    },
    caret: {
      marginLeft: 0,
      marginRight: 0,
    },
    caretSub: {
      marginLeft: 0,
      marginRight: 0,
      justifyContent: "right",
    },
    primary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    secondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
    error: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
    subMenuLabel: {
      marginLeft:theme.spacing(4),
    },
    subMenuLabel2: {
      marginLeft:theme.spacing(5),
    },
    newIcon: {
      color: "#cf5250",
    },
    categoryLbl: {
      fontSize: 13,
      color: "#5d5d5d",
      marginLeft: "25px",
      paddingBottom: "8px",
      paddingTop: theme.spacing(1),
    }
});

export default SidebarItemStyles;